import { useGetCurrentUserQuery } from "@/setup/frontend/api/apiHooks";

export function IfImpersonating({
	children,
	fallback = null,
}: {
	children: React.ReactNode;
	fallback?: React.ReactNode;
}) {
	const userQuery = useGetCurrentUserQuery();

	if (userQuery.data?.impersonatorUserId) {
		return children;
	}

	return fallback ?? null;
}
